<template>
    <div class="page-box fix" v-bind:class="{center: placement === 'center'}">
        <div class="page-wrap fix" v-bind:class="{l: placement === 'left', r: placement === 'right'}">
            <span class="total-des l">共{{pages}}页/{{total}}条</span>
            <ul v-if="pageList.length === 0" class="l fix">
                <li class="cur">1</li>
            </ul>
            <ul v-else class="l fix">
                <li v-for="(item, index) in pageList" :key="index" v-bind:class="{cur: current === item.val}" @click="setCurrent(item.val)">{{item.txt}}</li>
            </ul>
            <a v-if="pageList.length === 0" class="page-ele next-page l disabled" href="javascript: void(0)">下一页</a>
            <a v-else class="page-ele next-page l" v-bind:class="{disabled: current === pages}" href="javascript: void(0)" @click="setCurrent(current + 1)">下一页</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Pagination',
        props: {
            size: {
                type: Number,
                default: 10
            },
            total: {
                type: Number,
                default: 0
            },
            current: {
                type: Number,
                default: 1
            },
            pageGroup: {
                type: Number,
                default: 9
            },
            placement: {
                type: String,
                default: 'left',
            },
        },
        computed: {
            pages () {
                return Math.ceil(this.total / this.size)
            },
            pageList () {
                let len = this.pages,
                    count = Math.floor(this.pageGroup / 2),
                    center = this.current,
                    temp = [],
                    list = []
                if(len <= this.pageGroup){
                    while(len--){
                        temp.push({
                            txt: this.pages - len,
                            val: this.pages - len
                        })
                    }
                    return temp
                }
                while (len--) {
                    temp.push(this.pages - len)
                }
                let idx = temp.indexOf(center)
                if (idx < count) {
                    center = center + count - idx
                }
                if (this.current > this.pages - count) {
                    center = this.pages - count
                }
                temp = temp.splice(center - (count - 2) - 1, this.pageGroup - 4)
                do {
                    let t = temp.shift()
                    list.push({
                        txt: t,
                        val: t
                    })
                } while (temp.length)
                if (this.pages > this.pageGroup) {
                    if (this.current > count + 1) {
                        list.unshift({txt: '...', val: list[0].val - 1})
                    } else {
                        list.unshift({txt: 2, val: 2})
                    }
                    if (this.current < this.pages - count) {
                        list.push({txt: '...', val: list[list.length - 1].val + 1})
                    } else {
                        list.push({txt: this.pages - 1, val: this.pages - 1})
                    }
                    // 添加首页和尾页
                    list.unshift({txt: 1, val: 1})
                    list.push({txt: this.pages, val: this.pages})
                }
                return list
            }
        },
        methods: {
            setCurrent (idx) {
                if (this.current !== idx && idx > 0 && idx < this.pages + 1) {
                    this.$emit('on-change', idx)
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .fix {
        &::before, &::after {
            content: "";
            width: 100%;
            height: 0;
            visibility: hidden;
            clear: both;
        }
    }
    .l {
        float: left;
    }
    .r {
        float: right;
    }
    .page-box{
        &.center{
            text-align: center;
        }
        .page-wrap{
            display: inline-block;
        }
        .total-des{
            line-height: 38px;
        }
        ul{
            padding-left: 22px;
            padding-right: 26px;
            li{
                float: left;
                width: 38px;
                height: 38px;
                margin: 0 5px;
                background-color: #fff;
                border: 1px solid #e5e5e5;
                text-align: center;
                line-height: 38px;
                cursor: pointer;
                &.cur{
                    background-color: #006ab9;
                    border: none;
                    color: #fff;
                    pointer-events: none;
                    cursor: default;
                }
                &.no-event{
                    pointer-events: none;
                    cursor: default;
                }
            }
        }
        .next-page{
            display: block;
            width: 68px;
            height: 38px;
            background-color: #006ab9;
            color: #fff;
            text-align: center;
            line-height: 38px;
            cursor: pointer;
            &.disabled{
                border: 1px solid #e5e5e5;
                background-color: transparent;
                color: #5a5a5a;
                pointer-events: none;
                cursor: default;
            }
        }
    }
</style>
